var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('codemirror',{ref:"cmEditor",attrs:{"value":_vm.code,"options":_vm.cmOptions},on:{"ready":_vm.onCmReady,"input":_vm.onCmCodeChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }